// removed by extract-text-webpack-plugin
module.exports = {"header":"header___5ptB3","logo":"logo___11RLE","menu":"menu___3GSvP","trigger":"trigger___1oIbq","right":"right___2IyPv","action":"action___GkfFu","account":"account___1Vy8H","avatar":"avatar___zm5dq","name":"name___1nA9e"};


//////////////////
// WEBPACK FOOTER
// ./src/components/ant-design-pro/GlobalHeader/index.less
// module id = ne76
// module chunks = 2